const PersonIcon = ({ color = '#fff', width = '22', height = '22', className }) => {

    return (
        <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="8" r="3.3" stroke={color} strokeWidth="1.7" />
            <path d="M4.75 19.5c0-3.6 3.25-6 7.25-6s7.25 2.4 7.25 6" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
        </svg>
    )

};

export default PersonIcon;
